module.exports = __webpack_public_path__ + "static/media/lion_roaring.a76c864a.mp4";